const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

let logoutCallback: (() => void) | null = null;

export function onLogout(cb: () => void) {
  logoutCallback = cb;
}

interface RequestOptions {
  method?: string;
  body?: unknown;
  raw?: boolean;
}

async function request<T>(path: string, opts: RequestOptions = {}): Promise<T> {
  const { method = 'GET', body, raw = false } = opts;

  const secret = sessionStorage.getItem('adminSecret');
  const headers: Record<string, string> = {
    'X-Admin-Secret': secret ?? '',
  };

  if (body !== undefined) {
    headers['Content-Type'] = 'application/json';
  }

  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401) {
    sessionStorage.removeItem('adminSecret');
    logoutCallback?.();
    throw new Error('Unauthorized');
  }

  if (!res.ok) {
    const text = await res.text();
    let message = `HTTP ${res.status}`;
    try {
      const json = JSON.parse(text);
      message = json.error?.message ?? json.message ?? message;
    } catch {
      if (text) message = text;
    }
    throw new Error(message);
  }

  if (raw) {
    return res.blob() as unknown as T;
  }

  return res.json() as Promise<T>;
}

export const api = {
  get<T>(path: string) {
    return request<T>(path);
  },
  post<T>(path: string, body?: unknown) {
    return request<T>(path, { method: 'POST', body });
  },
  put<T>(path: string, body?: unknown) {
    return request<T>(path, { method: 'PUT', body });
  },
  del<T>(path: string, body?: unknown) {
    return request<T>(path, { method: 'DELETE', body });
  },
  raw(path: string) {
    return request<Blob>(path, { raw: true });
  },
};
